<div class="pet-view-container">
  <div class="pet-header">
    <div>
      <h1>Padrón de Mascotas Registradas</h1>
      <p>Consulta el historial clínico, estatus y tutores responsables de animales registrados.</p>
    </div>
    <div class="search-box">
      <input
        type="text"
        [formControl]="filter"
        placeholder="Buscar por nombre, folio, tutor o estatus..."
        class="search-input"
      />
    </div>
  </div>

  @if (filteredData.length === 0) {
    <div class="empty-state">
      <div class="empty-icon">🐾</div>
      <h2>No se encontraron mascotas</h2>
      <p>No hay registros que coincidan con la búsqueda o el padrón está vacío.</p>
    </div>
  } @else {
    <div class="pet-grid">
      @for (pet of pagedPets; track pet.id || pet.folio || $index) {
        <article class="pet-card">
          <div class="pet-card-header">
            <div>
              <h3>{{ pet.petName }}</h3>
              <span class="pet-folio">{{ pet.folio || 'S/F' }}</span>
            </div>
            <span
              class="status-badge"
              [class.badge-completed]="pet.status === 'COMPLETADO'"
              [class.badge-pending]="pet.status === 'PENDIENTE'"
            >
              {{ pet.status || 'REGISTRADO' }}
            </span>
          </div>

          <div class="pet-card-body">
            <div class="pet-info-row">
              <span class="label">Especie / Raza:</span>
              <span class="value">{{ pet.petType || 'Canino' }} - {{ pet.petRace || 'Mestizo' }}</span>
            </div>
            <div class="pet-info-row">
              <span class="label">Sexo / Edad:</span>
              <span class="value">{{ pet.petSex || 'N/A' }} | {{ pet.petAge || 'N/A' }}</span>
            </div>
            <div class="pet-info-row">
              <span class="label">Tutor Responsable:</span>
              <span class="value">{{ pet.responsibleOwner || 'No especificado' }}</span>
            </div>
            <div class="pet-info-row">
              <span class="label">Contacto:</span>
              <span class="value">{{ pet.phoneNumbers || pet.email || 'N/A' }}</span>
            </div>
          </div>
        </article>
      }
    </div>

    <app-pagination
      [(page)]="page"
      [totalItems]="filteredData.length"
      [pageSize]="pageSize"
    ></app-pagination>
  }
</div>
